module.exports = __webpack_public_path__ + "static/media/header.a43af9df.png";